module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#sliceModal"
    },
    on: {
      "click": _vm.resetSlice
    }
  }, [_vm._v("+ Add Slice")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#sliceImgModal"
    },
    on: {
      "click": _vm.resetSlice
    }
  }, [_vm._v("+ Add Image Slice")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#sliceQuoteModal"
    },
    on: {
      "click": _vm.resetSlice
    }
  }, [_vm._v("+ Add Quote Slice")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#sliceCreditsModal"
    },
    on: {
      "click": _vm.resetSlice
    }
  }, [_vm._v("+ Add Credits Slice")]), _vm._v(" "), _c('modal-slice', {
    attrs: {
      "id": "sliceModal",
      "modal-title": _vm.modalTitle,
      "current-slice": _vm.currentSlice
    },
    on: {
      "save": _vm.saveSlice
    }
  }), _vm._v(" "), _c('modal-img-slice', {
    attrs: {
      "id": "sliceImgModal",
      "modal-title": _vm.modalTitle,
      "current-slice": _vm.currentSlice
    },
    on: {
      "save": _vm.saveSlice
    }
  }), _vm._v(" "), _c('modal-quote', {
    attrs: {
      "id": "sliceQuoteModal",
      "modal-title": _vm.modalTitle,
      "current-slice": _vm.currentSlice
    },
    on: {
      "save": _vm.saveSlice
    }
  }), _vm._v(" "), _c('modal-credits', {
    attrs: {
      "id": "sliceCreditsModal",
      "modal-title": _vm.modalTitle,
      "current-slice": _vm.currentSlice
    },
    on: {
      "save": _vm.saveSlice
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    directives: [{
      name: "sortable",
      rawName: "v-sortable",
      value: ({
        handle: '.handle',
        onUpdate: _vm.onDragSlice
      }),
      expression: "{ handle: '.handle', onUpdate: onDragSlice }"
    }],
    staticClass: "panel-group list-group",
    attrs: {
      "id": "slices"
    }
  }, _vm._l((_vm.slices), function(slice, sliceKey) {
    return _c('div', {
      staticClass: "panel panel-default list-group-item"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('h4', {
      staticClass: "panel-title"
    }, [_vm._m(1, true), _vm._v(" "), (slice.name == '' || !slice.name) ? _c('a', {
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#slices",
        "href": '#' + slice.sliceKey
      }
    }, [_vm._v("\n                    Slice #" + _vm._s(slice.sliceKey) + "\n                  ")]) : _c('a', {
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#slices",
        "href": '#' + slice.sliceKey
      }
    }, [_vm._v("\n                    " + _vm._s(slice.name) + "\n                  ")]), _vm._v(" "), _c('b', [_vm._v("Index: " + _vm._s(slice.index))]), _vm._v(" "), _c('a', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:top",
        value: ('Remove'),
        expression: "'Remove'",
        arg: "top"
      }],
      staticClass: "action",
      class: {
        disabled: slice.locked
      },
      on: {
        "click": function($event) {
          _vm.removeSlice(slice, slice.sliceKey)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('a', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:top",
        value: ('Edit'),
        expression: "'Edit'",
        arg: "top"
      }],
      staticClass: "action",
      on: {
        "click": function($event) {
          _vm.editSlice(slice, slice.sliceKey)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-collapse collapse",
      attrs: {
        "id": slice.sliceKey
      }
    }, [_c('div', {
      staticClass: "panel-body"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(slice.content)
      }
    })])])])
  }))], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('strong', [_vm._v("Slices")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "action handle"
  }, [_c('i', {
    staticClass: "fa fa-bars handle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2967acca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/back/page-edit/SliceManager.vue
// module id = 259
// module chunks = 1